export default "__VITE_ASSET__Dnx_UE4y__"